import { render, staticRenderFns } from "./SettingsGdpr.vue?vue&type=template&id=5b65eda5&scoped=true&"
import script from "./SettingsGdpr.vue?vue&type=script&lang=js&"
export * from "./SettingsGdpr.vue?vue&type=script&lang=js&"
import style0 from "./SettingsGdpr.vue?vue&type=style&index=0&id=5b65eda5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b65eda5",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/SettingsGdpr.vue
// module id = null
// module chunks = 